import React from 'react';
import { Col, Container, Row } from 'reactstrap';

function GridWrapper({ grid, size = { sm: 4 } }) {
  return (
    <Container>
      <Row>
        {grid.map((item, i) => (
          <Col key={`${item.title} ${i}`} {...size} className="mb-5">
            {item}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default GridWrapper;
